import {
  ArrowBigRightDash,
  ArrowLeftRight,
  MoveHorizontal,
  ReplyAll,
  Search,
} from "lucide-react";
import type { ComponentType, ReactNode } from "react";

import { BaseReportPanel } from "./base-report-panel";
import { DsdComparePanel } from "./dsd-compare-panel";
import { DsdReviewPanel } from "./dsd-review-panel";
import { FinalReviewPanel } from "./final-review-panel";
import { IxdValueInputPanel } from "./ixd-value-input-panel";
import { XbrlTaggingPanel } from "./xbrl-tagging-panel";

import { FileFormatIcon } from "@/components/file-drop-zone";

const connector = "size-[18px] shrink-0 text-label-neutral";

export type Step = {
  id: string;
  label: string;
  description: string;
  xbrl?: boolean;
  thumb: ReactNode;
  /** RSB 작업 패널. 없으면 제목·설명만 보인다 */
  Panel?: ComponentType;
};

export const STEPS: readonly Step[] = [
  {
    id: "base-report",
    Panel: BaseReportPanel,
    label: "기초 보고서 작업",
    description:
      "전기 DSD를 엑셀로 이어서 작성하거나, 정산표를 DSD로 변환해 바로 시작해요",
    thumb: (
      <>
        <FileFormatIcon format="excel" />
        <ArrowLeftRight className={connector} strokeWidth={1.8} />
        <FileFormatIcon format="dsd" />
      </>
    ),
  },
  {
    id: "dsd-review",
    Panel: DsdReviewPanel,
    label: "DSD 검토",
    description: "본문과 주석의 연동값 불일치, 오탈자를 자동으로 잡아드려요",
    thumb: (
      <>
        <FileFormatIcon format="dsd" />
        <Search
          className="absolute top-[-4px] right-[37px] size-6 text-label-neutral"
          strokeWidth={1.8}
        />
      </>
    ),
  },
  {
    id: "dsd-compare",
    Panel: DsdComparePanel,
    label: "DSD 대사",
    description:
      "감사 반영 전후를 비교해 변경 내역, 단수 차이, 합계 정합성을 확인해요",
    thumb: (
      <>
        <FileFormatIcon format="dsd" />
        <MoveHorizontal className={connector} strokeWidth={1.8} />
        <FileFormatIcon format="dsd" />
      </>
    ),
  },
  {
    id: "xbrl-tagging",
    label: "XBRL 태깅",
    description:
      "완성된 DSD를 워크북에 올려 전기 태그를 가져오거나 택소노미를 새로 매핑해요",
    xbrl: true,
    Panel: XbrlTaggingPanel,
    thumb: (
      <>
        <FileFormatIcon format="dsd" />
        <ReplyAll className={`${connector} -scale-x-100`} strokeWidth={1.8} />
        <FileFormatIcon format="xbrl" />
      </>
    ),
  },
  {
    id: "ixd-value-input",
    label: "IXD 값 입력",
    description:
      "값만 빠르게 채우거나, 워크북과 나란히 대조하며 채울 수 있어요",
    xbrl: true,
    Panel: IxdValueInputPanel,
    thumb: (
      <>
        <FileFormatIcon format="dsd" />
        <ArrowBigRightDash className={connector} strokeWidth={1.8} />
        <FileFormatIcon format="xbrl" />
      </>
    ),
  },
  {
    id: "final-review",
    label: "보고서 최종 검토",
    description: "단위 차이까지 포함해 일치 · 불일치 항목을 한눈에 보여드려요",
    xbrl: true,
    Panel: FinalReviewPanel,
    thumb: (
      <>
        <FileFormatIcon format="dsd-xbrl" />
        <MoveHorizontal className={connector} strokeWidth={1.8} />
        <FileFormatIcon format="xbrl" />
      </>
    ),
  },
];
